var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandVivaldiStyleBrand = function SvgBrandVivaldiStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandVivaldiStyleBrand__clip0_3953_124480)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF3939",
    d: "M12 23.963c5.247 0 8.163 0 10.074-1.904 1.905-1.905 1.905-4.816 1.905-10.06 0-5.242 0-8.154-1.905-10.058C20.164.042 17.247.042 12 .042s-8.163 0-10.074 1.904C.021 3.85.021 6.762.021 12.006c0 5.242 0 8.154 1.905 10.058 1.91 1.899 4.827 1.899 10.074 1.899"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandVivaldiStyleBrand__paint0_linear_3953_124480)",
    d: "M19.79 7.58a8.97 8.97 0 0 0-5.485-4.225C9.511 2.073 4.585 4.91 3.3 9.695a8.9 8.9 0 0 0 .921 6.841q.023.043.053.085l4.22 7.305c.7.021 1.459.027 2.274.027h1.19c2.331 0 4.205 0 5.737-.17 1.91-.21 3.279-.68 4.337-1.735 1.542-1.54 1.836-3.745 1.894-7.316A5112 5112 0 0 0 19.79 7.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.305 5.676c-3.5-3.503-9.179-3.503-12.684 0-3.5 3.502-3.5 9.178 0 12.675 3.5 3.502 9.179 3.502 12.684 0 3.506-3.503 3.506-9.178 0-12.675m-.537 4.12-4.436 7.71c-.274.48-.674.766-1.221.808-.611.042-1.095-.216-1.406-.744-.937-1.609-1.863-3.228-2.79-4.842-.562-.981-1.13-1.962-1.694-2.949-.568-.991.074-2.2 1.21-2.257.6-.032 1.064.248 1.369.77.416.712.826 1.435 1.242 2.152.3.517.59 1.04.895 1.545.442.744 1.095 1.16 1.963 1.214a2.39 2.39 0 0 0 2.516-2.12c.01-.096.016-.196.02-.243a2.46 2.46 0 0 0-.252-1.113c-.458-.918.032-1.947 1.027-2.168.81-.18 1.652.416 1.758 1.24.052.353-.022.685-.2.996"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandVivaldiStyleBrand__paint0_linear_3953_124480",
    x1: 454.919,
    x2: 1594.07,
    y1: 122.397,
    y2: 2105.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandVivaldiStyleBrand__clip0_3953_124480"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandVivaldiStyleBrand);
export { ForwardRef as ReactComponent };